import { render, staticRenderFns } from "./interestCardComponent.vue?vue&type=template&id=0cc41d0a&scoped=true"
import script from "./interestCardComponent.vue?vue&type=script&lang=js"
export * from "./interestCardComponent.vue?vue&type=script&lang=js"
import style0 from "./interestCardComponent.vue?vue&type=style&index=0&id=0cc41d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc41d0a",
  null
  
)

export default component.exports